import styled from 'styled-components';

export const StyledLogo = styled.div`
  display: flex;
  align-items: center;
  max-width: 300px;
  .logoPlaceholder {
    background: #f7f7f7;
    border: 1px dashed var(--color-smoke-800);
    border-radius: 5px;
    padding: 6px;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 11px;
    line-height: 15px;
    color: var(--color-smoke-800);
    width: 44px;
    height: 44px;
    text-align: center;
    cursor: pointer;
  }

  .companyname {
    margin-left: 10px;
    font-weight: 600;
    font-size: 20px;
    line-height: 29px;
    color: #12344d;
    word-break: break-word;
  }
`;

export const headerInputStyle = {
  width: '480px',
  color: 'var(--color-smoke-800)',
  fontSize: '16px',
  lineHeight: '1.8',
  fontWeight: 500,
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
};
